export default "__VITE_ASSET__BEnW63eK__"